module.exports = __webpack_public_path__ + "./rules/SportsRulesFR.79dc2489f0671ad0ffbd9cffde651d0e.pdf";